import { render, staticRenderFns } from "./innerBoxLabelTipsDialog.vue?vue&type=template&id=7d79721b&scoped=true"
import script from "./innerBoxLabelTipsDialog.vue?vue&type=script&lang=js"
export * from "./innerBoxLabelTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./innerBoxLabelTipsDialog.vue?vue&type=style&index=0&id=7d79721b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79721b",
  null
  
)

export default component.exports